import BaseClass from "./BaseClass";

class DirectoryPeriods extends BaseClass {
  static get schema() {
    return {
      name: {
        editable: true,
        props: { sortable: true }
      },
      value: {
        editable: true,
        props: { sortable: true }
      },
      trial: {
        editable: true,
        type: Boolean,
        props: { sortable: true }
      },
      created_at: {
        props: { sortable: true }
      },
      updated_at: {
        props: { sortable: true }
      }
    };
  }

  get actions() {
    return {
      edit: {
        handler: () => Promise.resolve(this.uuid),
        props: { type: "info", size: "small" },
        in_edit_mode: false,
        in_submenu: false
      },
      delete: {
        handler: () => this._handleDelete(),
        props: { type: "danger", size: "small" },
        in_edit_mode: false,
        in_submenu: true
      },
      save: {
        handler: () => this._handleSave(),
        props: { type: "success", size: "small" },
        in_edit_mode: true,
        in_submenu: false
      },
      cancel: {
        handler: () => this._handleCancel(),
        props: { type: "default", size: "small" },
        in_edit_mode: true,
        in_submenu: false
      }
    };
  }

  beShownForFilter(filter) {
    return !filter || this.name.toLowerCase().includes(filter.toLowerCase());
  }

  _handleSave() {
    return this._api
      .mutate({
        mutation: require("../../graphql/periods/periods_save.graphql"),
        variables: Object.assign({ trial: !!this.trial }, this)
      })
      .then(res => {
        Object.assign(this, res.data.directory_periods);
        return "saved";
      });
  }

  _handleDelete() {
    return this._confirm("Are you sure want to delete this period?")
      .then(() => {
        return this._api
          .mutate({
            mutation: require("../../graphql/periods/periods_save.graphql"),
            variables: Object.assign({ action: "delete" }, this)
          })
          .then(res => {
            return "deleted";
          });
      })
      .catch(() => {
        return "scipped";
      });
  }

  _handleCancel() {
    if (typeof this.uuid === "undefined") {
      return Promise.reject();
    } else {
      return Promise.resolve("canceled");
    }
  }
}

export default DirectoryPeriods;
